// src/components/Books.js
import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import "./Books.css"; // Import the CSS file
import booksData from "./booksData"; // Import the books data
import { useLanguage } from "../LanguageContext";

function Books() {
  const { language } = useLanguage();

  return (
    <div className="books-wrapper">
      <h2 className="section-title books-title">
        {language === 'ar' ? 'إصدارات' : language === 'fr' ? 'PUBLICATIONS' : 'PUBLICATIONS'}
      </h2>
      <div className="books-container">
        {booksData.map((book) => (
          <div className={`book-card ${book.isNew ? 'featured-book' : ''}`} key={book.id}>
            <div className="book-image-container">
              {book.isNew && (
                <div className="book-badge">
                  {language === 'ar' ? 'جديد' : language === 'fr' ? 'Nouveau' : 'New'}
                </div>
              )}
              <img
                src={book.image}
                alt={book.alt}
                className={`book-image ${book.isMontage ? 'montage' : ''} ${book.isZoomed ? 'zoomed' : ''}`}
                loading="lazy"
              />
            </div>
            
            <div className="book-info">
              <h3>{book.title[language] || book.title.fr}</h3>
              
              {book.subtitle && (
                <p className="book-subtitle">
                  {book.subtitle[language] || book.subtitle.fr}
                </p>
              )}
              
              <p className="book-date">
                {book.isNew 
                  ? (language === 'ar' ? `سيصدر في ${typeof book.release_date === 'object' ? book.release_date.ar : book.release_date}` : language === 'fr' ? `Sortie le ${typeof book.release_date === 'object' ? book.release_date.fr : book.release_date}` : `Releasing ${typeof book.release_date === 'object' ? book.release_date.en : book.release_date}`)
                  : (language === 'ar' ? `نشر في ${book.release_date}` : language === 'fr' ? `Publié en ${book.release_date}` : `Published in ${book.release_date}`)
                }
              </p>

              <Link to={`/books/${book.id}`} className="view-details-button">
                {language === 'ar' ? 'التفاصيل' : language === 'fr' ? 'Détails' : 'Details'}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Books;
